/* eslint-disable array-callback-return*/
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react"
import { Paper, TableCell, TableRow } from "@material-ui/core"
import {
  IconButtonDatatable,
  Loading,
  ModalDeleteConfirm,
  TableAction,
  TableCellDefault,
  TableWrapper,
} from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"

import {
  FormTabBed,
  RESET_STATE_TAB_BED,
  headCells,
  getAllBed,
  deleteBedById,
  STYLE_DEFAULT_TAB_BED,
  RESET_FILTER_TAB_BED,
  useInitialGolonganKelas,
} from "./ui"
import {
  scrollToTop,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers"
import { useDatatables, useFetch } from "App/hooks"
import FormFilterTabBed from "./ui/FormFilterTabBed"
import { SelectIcon } from "App/Assets"
import { StatusBed } from "./ui/helpers"
import { TYPE_INSTANCE2 } from "App/constants"
import { LIST_URL_MASTER } from "utils/masters"
import { useSelector } from "react-redux"
export default function TabBed({
  withForm = true,
  onlySelect = false,
  handleClickSelect,
}) {
  const classes = STYLE_DEFAULT_TAB_BED()

  const [formData, setFormData] = useState(RESET_STATE_TAB_BED)
  const [formFilter, setFormFilter] = useState(RESET_FILTER_TAB_BED)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)

  const ruangAplicare = useFetch(
    TYPE_INSTANCE2,
    LIST_URL_MASTER.ruang_aplicares.list,
  )

  const [selectRuangAplicare, setSelectRuangAplicare] = useState([])
  const golonganKelas = useInitialGolonganKelas()
  const { master } = useSelector((state) => state)

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  })

  useEffect(() => {
    setNewData()
  }, [])

  const setVal = (row) => {
    const ruangAplicareName = isNull(row.ruang_aplicares)
      ? "Pilih Ruang Aplicare"
      : ruangAplicare[0].filter((item) => item.kode === row.ruang_aplicares)[0]

    const jenisLayanan = master.all_jenis_layanan.list_select.find(
      (x) => parseInt(x.value) === parseInt(row.jenis_layanan_id),
    )

    setFormData({
      id: row.id,
      name: row.name,

      kelas_id: row.kelas_id,
      kelas_name: row.name_kelaskamar,

      kelaskamarsirsonline: row.kelaskamarsirsonline,
      kelaskamarsirsonline_name: row.name_kelassirsonline,

      kamar_id: row.kamar_id,
      kamar_name: row.name_kamar,

      gol_golongankelasaplicares: row.gol_golongankelasaplicares,
      gol_golongankelasaplicares_name: row.name_golongankelasaplicare,

      jenis_layanan_id: row.jenis_layanan_id,
      jenis_layanan_name: jenisLayanan.label,

      ruang_aplicares: row.ruang_aplicares,
      ruang_aplicares_name: isNull(row.ruang_aplicares)
        ? "Pilih Ruang Aplicare"
        : `[${ruangAplicareName.kode}] ${ruangAplicareName.name}`,

      ruang_sirsonline: row?.ruang_sirsonline,
      ruang_sirsonline_name: row?.ruang_sirsonline_name,

      icekbridging: row.icekbridging,
      icekbridging_sirsonline: row.icekbridging_sirsonline,

      remark: row?.remark,
      status: row.status,
    })

    const kodeRuangAplicare = golonganKelas.filter(
      (item) => item.value === row.gol_golongankelasaplicares,
    )

    if (!isNull(kodeRuangAplicare[0].kode_ruang_aplicares)) {
      const _temp = []
      ruangAplicare[0].map((item) => {
        const check = kodeRuangAplicare[0].kode_ruang_aplicares
          .split(",")
          .filter((e) => e === item.kode)
        if (check.length > 0) {
          _temp.push({
            id: item.id,
            value: item.kode,
            label: `[${item.kode}] ${item.name}`,
            name: `(${item.id}) ${item.name}`,
          })
        }
      })

      setSelectRuangAplicare(_temp)
    }
  }

  const setNewData = async (formSearch = formFilter) => {
    setLoading(true)
    const res = await getAllBed(formSearch)
    if (res.state) {
      setRows(res.data)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  async function deleteList() {
    const res = await deleteBedById(formData.id)

    if (res.state) {
      defaultToastSuccess(res.message)
      setNewData()
    } else {
      defaultToastError(res.message)
    }

    setShowModalDeleteConfirm(false)
  }
  return (
    <div className={classes.root}>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList(formData.id)}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {withForm && (
        <FormTabBed
          formData={formData}
          setFormData={setFormData}
          setNewData={setNewData}
          ruangAplicare={ruangAplicare}
          golonganKelas={golonganKelas}
          selectRuangAplicare={selectRuangAplicare}
          setSelectRuangAplicare={setSelectRuangAplicare}
        />
      )}

      <div className={`${withForm ? "mt-2" : ""}`}>
        <Paper className={classes.paper}>
          <FormFilterTabBed
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <div>
            <TableWrapper
              title="Daftar BED"
              setQ={setQ}
              order={order}
              orderBy={orderBy}
              withExportButton={false}
              withSearch={false}
              withAddButton={false}
              handleRequestSort={handleRequestSort}
              length={length}
              rows={rows}
              headCells={headCells}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              hasShadow={false}
            >
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "transparent" : "#fff",
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        padding="none"
                        align="center"
                      >
                        {index + 1}
                      </TableCell>

                      <TableCell component="th" scope="row" padding="none">
                        {onlySelect ? (
                          <IconButtonDatatable
                            color="secondary"
                            aria-label="delete"
                            onClick={() => handleClickSelect(row)}
                            style={{
                              background: "#D8D8D8",
                              borderRadius: "8px",
                              padding: "4px",
                            }}
                          >
                            <SelectIcon
                              width={"12"}
                              height={"14"}
                              fill={"#fff"}
                            />
                          </IconButtonDatatable>
                        ) : (
                          <TableAction
                            clickDelete={() => {
                              setFormData({
                                ...formData,
                                id: row?.id,
                              })
                              setShowModalDeleteConfirm(!showModalDeleteConfirm)
                            }}
                            clickUpdate={() => {
                              setVal(row)
                              scrollToTop()
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell align="left">{row?.id}</TableCell>

                      <TableCell align="left">{row?.name}</TableCell>
                      <TableCell align="left">{row?.ruang_aplicares}</TableCell>
                      <TableCell align="left">{row?.name_kelaskamar}</TableCell>
                      <TableCell align="left">{row?.name_ruangkamar}</TableCell>
                      <TableCell align="left">
                        {row?.name_golongankelasaplicare}
                      </TableCell>
                      <TableCell align="left">{row?.name_kamar}</TableCell>
                      <TableCell align="left">
                        {row?.name_kelassirsonline}
                      </TableCell>
                      <TableCell align="center">
                        <StatusBed status={row?.status} />
                      </TableCell>
                      <TableCellDefault row={row} />
                    </TableRow>
                  )
                })}
            </TableWrapper>
          </div>
        </Paper>
      </div>
    </div>
  )
}
